import {Navigate, Route, Routes} from 'react-router-dom'
import {ExamQuizHome} from './components/ExamQuizHome'
import {Quiz} from '../classes/quiz/Quiz'

const ExamLoginPage = () => (
  <Routes>
    <Route index element={<ExamQuizHome />} />
    <Route path='quiz/:quizId' element={<Quiz />} />
    <Route path='*' element={<Navigate to='/exam-login' />} />
  </Routes>
)

export default ExamLoginPage
